<template>
	<div>
		<div class="huwrots" v-if="hideFloatButtons">
			<ul>
				<li @click="topath('Forum')">
					<a href="javascript:;">
						<img class="ico" src="../assets/images/qz1.png" alt="" />
						<h4>{{ $t('nav.Forum') }}</h4>
					</a>
				</li>
				<li @click="topath('demand')">
					<a href="javascript:;">
						<img class="ico" src="../assets/images/qz2.png" alt="" />
						<h4>{{ $t('nav.demand') }}</h4>
					</a>
				</li>
				<li @click="topath('video')">
					<a href="javascript:;">
						<img class="ico" src="../assets/images/qz3.png" alt="" />
						<h4>{{ $t('nav.video') }}</h4>
					</a>
				</li>
				<li @click="topath('message')">
					<a href="javascript:;">
						<img class="ico" src="../assets/images/qz2.png" alt="" />
						<h4>{{ $t('nav.Leavemessage') }}</h4>
					</a>
				</li>
				<li @click="topaths('postEdit')" v-if="islunt" style="background:#FF8C37;">
					<a href="javascript:;">
						<img class="ico" src="../assets/images/qw47.png" alt="" />
						<h4>{{ $t('nav.publish') }}</h4>
					</a>
				</li>
				<li @click="topaths('demandEdit')" v-if="isxuq" style="background:#FF8C37;">
					<a href="javascript:;">
						<img class="ico" src="../assets/images/qw47.png" alt="" />
						<h4>{{ $t('nav.publish') }}</h4>
					</a>
				</li>
				<li @click="topaths('videoPublish')" v-if="isvideo" style="background:#FF8C37;">
					<a href="javascript:;">
						<img class="ico" src="../assets/images/qw47.png" alt="" />
						<h4>{{ $t('nav.publish') }}</h4>
					</a>
				</li>
			</ul>
		</div>
		<div class="footer">
			<div class="wrap">
				<div class="tps">
					<div class="ls">
						<a href="#" class="logo"><img src="../assets/images/flogo.png" alt=''></a>
						<div class="txt">
							<p><img src="../assets/images/qw68.png" alt=''>Service@unisomarine.com /
								Info@unisomarine.com
							</p>
							<p><img src="../assets/images/qw69.png" alt=''>+852 4640 3063</p>
						</div>
					</div>
					<dl>
						
						<dd><a href="javascript:;" @click="topath('service',{type:0})">{{ $t('nav.AboutUs') }}</a>
						</dd>
						<dd><a href="javascript:;" @click="topath('service',{type:3})">{{ $t('nav.privacypolicy') }}</a>
						</dd>
						<dd><a href="javascript:;"
								@click="topath('service',{type:2})">{{ $t('nav.tremsandconditions') }}</a></dd>
						<dd><a href="javascript:;"
								@click="topath('feedback')">{{ $t('nav.complaintsandsuggestions') }}</a></dd>
						<dd><a href="javascript:;" @click="topath('service',{type:1})">{{ $t('nav.UserAgreement') }}</a>
						</dd>
					</dl>
				</div>
				<div class="copyright">
					{{ $t('nav.copyright') }} © MARINELINKCO.COM. {{ $t('nav.AllRightsReserved') }}.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		get,
		post
	} from '@/api/api.js'
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'

	export default {
		name: 'Footer',
		props: {
			msg: String,
		},
		data() {
			return {
				user_infos: '',
			}
		},
		computed: {
			hideFloatButtons() {
				// 获取当前路由名称
				const currentRoute = this.$route.name
				// 当路由是 user 时隐藏悬浮按钮
				return currentRoute !== 'user'
			},
			islunt() {
				// 获取当前路由名称
				const currentRoute = this.$route.name
				// 当路由是 user 时隐藏悬浮按钮
				if (currentRoute == 'Forum' || currentRoute == 'postDetail') {
					return true;
				} else {
					return false;
				}
				return currentRoute == 'Forum'
			},
			isxuq() {
				// 获取当前路由名称
				const currentRoute = this.$route.name
				// 当路由是 user 时隐藏悬浮按钮
				if (currentRoute == 'demand' || currentRoute == 'Netails') {
					return true;
				} else {
					return false;
				}
				return currentRoute == 'demand'
			},
			isvideo() {
				// 获取当前路由名称
				const currentRoute = this.$route.name
				// 当路由是 user 时隐藏悬浮按钮
				if (currentRoute == 'video' || currentRoute == 'videodel') {
					return true;
				} else {
					return false;
				}
				// return currentRoute == 'video'
			}

		},
		mounted() {
			this.getUser();
		},
		methods: {
			topath(path, query = {}) {
				this.$router.push({
					name: path,
					query: query
				});
			},
			topaths(path, query = {}) {
				let that = this;
				let locale = localStorage.getItem('locale');
				
				if (that.user_infos == '') {
					let msg = '您尚未登录，请先登录';
					if (locale === 'en') {
						msg = 'Not logged in, go login';
					}
					ElMessage.error(msg)
					setTimeout(() => {
						this.$router.push({
							name: 'login',
							query: {}
						});
					}, 1500)
				} else {
					this.$router.push({
						name: path,
						query: query
					});
				}
			},
			async getUser() {
				let that = this;
				try {
					const response = await post('getUser2', {}, 'json')
					if (response.code === 200 && response.data) {
						that.user_infos = response.data
					}
				} catch (error) {
					// console.error('获取用户信息失败:', error)
				}
			},
		}
	}
</script>

<style scoped>
	/* 你的样式保持不变 */
</style>